import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { Ge as t, hi as n, bo as r, fi as o } from "./abstract-base-8edf0a84-e11d45a3.js";
var a = {
    beaconTagName: "beacon-tabbed-hero"
  },
  s = t(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var c = /*#__PURE__*/function (_n) {
  _inherits(c, _n);
  function c() {
    var _this;
    _classCallCheck(this, c);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments)), _this.beaconTagName = a.beaconTagName;
    return _this;
  }
  _createClass(c, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(c.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return r(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<slot></slot>"])));
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(c), "styles", this), s];
    }
  }]);
  return c;
}(n(o));
c.tagName = a.beaconTagName;
export { c as BeaconTabbedHero };